import { ExplainCSVExportRow } from './explain-csv-export-row'

export class ExplainCSVExportPinnedProductRow extends ExplainCSVExportRow {
  public get totalScore(): number | null {
    return null
  }

  public get semanticSearchScore(): number | null {
    return null
  }

  public get topProductScore(): number | null {
    return null
  }

  public get topAttributesScore(): number | null {
    return null
  }

  public get termPositionScore(): number | null {
    return null
  }

  public get customizationScore(): number | null {
    return null
  }

  public get textualMatchTotalScore(): number | null {
    return null
  }

  textualMatchScore(textualMatchKey: string): number | null {
    return null
  }

  public get gbrBoostScore(): number | null {
    return null
  }

  public get gbrBuriesScore(): number | null {
    return null
  }

  public get functionScore(): number | null {
    return null
  }

  public get productBoostScore(): number | null {
    return null
  }

  public get attributeBoostScore(): number | null {
    return null
  }

  public get productBuryScore(): number | null {
    return null
  }

  public get attributeBuryScore(): number | null {
    return null
  }

  public get tieBreaker(): number | null {
    return null
  }
}
